/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Base_Unit_Type_Enum =
  | 'BAG'
  | 'BAG_IN_BOX'
  | 'BOTTLE'
  | 'BOX'
  | 'BOX_SET'
  | 'BULK'
  | 'CAN'
  | 'CARTON'
  | 'CUP'
  | 'FLASK'
  | 'JAR'
  | 'KEG'
  /**   */
  | 'NET'
  | 'PACK'
  | 'PIECE'
  | 'SACHET'
  | 'SLICE'
  | 'SPRAY'
  | 'TIN'
  | 'TRAY'
  /**   */
  | 'TUB'
  | 'TUBE';

export type Billing_Type_Enum =
  /** billed per unit */
  | 'FIXED'
  /** billed per measured weight */
  | 'WEIGHT_DEPENDENT';

export type Measurement_Unit_Enum =
  | 'CL'
  | 'G'
  | 'KG'
  | 'L'
  | 'ML'
  | 'T'
  /** Used to count units in logistical packages */
  | 'UNIT';

export type Trade_Item_Unit_Descriptor_Enum =
  | 'CASE'
  | 'CRATE'
  | 'DISPLAY'
  | 'HALF_CASE'
  | 'PALLET'
  | 'SACK'
  /** Used when base units are sold individually */
  | 'UNIT';

export type LastOrderByContractReferenceIdQueryVariables = Exact<{
  contractReferenceId?: string | null | undefined;
}>;


export type LastOrderByContractReferenceIdQuery = { order: Array<{ total_price_excl_tax: number | null, created_at: string, id: string, reference_id: string, items: Array<{ orderId: string, packagingId: string, price: number, quantity: number, weight: number | null, packaging: { id: string, content_measurement_unit: Types.Measurement_Unit_Enum | null, price: number, net_content: number | null, sku: number, trade_item_unit_descriptor: Types.Trade_Item_Unit_Descriptor_Enum, unit_quantity: number | null, product: { name: string, sub_family: string } | null, base_unit: { availability: string, id: string, content_measurement_unit: Types.Measurement_Unit_Enum | null, sku: number | null, unit_net_content: number | null, unit_quantity: number | null, unit_type: Types.Base_Unit_Type_Enum | null, billing_type: Types.Billing_Type_Enum, main_photo: { path: string, domain: string | null } | null } | null } }> }> };


export const LastOrderByContractReferenceIdDocument = /*#__PURE__*/ gql`
    query LastOrderByContractReferenceId($contractReferenceId: uuid) {
  order(
    where: {status: {_nin: [order_cancelled]}, contract: {reference_id: {_eq: $contractReferenceId}}}
    order_by: {created_at: desc}
    limit: 1
  ) {
    total_price_excl_tax
    created_at
    id
    reference_id
    items(where: {quantity: {_gt: 0}}) {
      orderId
      packagingId
      price
      quantity
      weight
      packaging {
        id
        product {
          name
          sub_family
        }
        base_unit {
          availability
          id
          main_photo {
            path
            domain
          }
          content_measurement_unit
          sku
          unit_net_content
          unit_quantity
          unit_type
          billing_type
        }
        content_measurement_unit
        price
        net_content
        sku
        trade_item_unit_descriptor
        unit_quantity
      }
    }
  }
}
    `;

/**
 * __useLastOrderByContractReferenceIdQuery__
 *
 * To run a query within a React component, call `useLastOrderByContractReferenceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastOrderByContractReferenceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastOrderByContractReferenceIdQuery({
 *   variables: {
 *      contractReferenceId: // value for 'contractReferenceId'
 *   },
 * });
 */
export function useLastOrderByContractReferenceIdQuery(baseOptions?: Apollo.QueryHookOptions<LastOrderByContractReferenceIdQuery, LastOrderByContractReferenceIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastOrderByContractReferenceIdQuery, LastOrderByContractReferenceIdQueryVariables>(LastOrderByContractReferenceIdDocument, options);
      }
export function useLastOrderByContractReferenceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastOrderByContractReferenceIdQuery, LastOrderByContractReferenceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastOrderByContractReferenceIdQuery, LastOrderByContractReferenceIdQueryVariables>(LastOrderByContractReferenceIdDocument, options);
        }
// @ts-ignore
export function useLastOrderByContractReferenceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LastOrderByContractReferenceIdQuery, LastOrderByContractReferenceIdQueryVariables>): Apollo.UseSuspenseQueryResult<LastOrderByContractReferenceIdQuery, LastOrderByContractReferenceIdQueryVariables>;
export function useLastOrderByContractReferenceIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LastOrderByContractReferenceIdQuery, LastOrderByContractReferenceIdQueryVariables>): Apollo.UseSuspenseQueryResult<LastOrderByContractReferenceIdQuery | undefined, LastOrderByContractReferenceIdQueryVariables>;
export function useLastOrderByContractReferenceIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LastOrderByContractReferenceIdQuery, LastOrderByContractReferenceIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LastOrderByContractReferenceIdQuery, LastOrderByContractReferenceIdQueryVariables>(LastOrderByContractReferenceIdDocument, options);
        }
export type LastOrderByContractReferenceIdQueryHookResult = ReturnType<typeof useLastOrderByContractReferenceIdQuery>;
export type LastOrderByContractReferenceIdLazyQueryHookResult = ReturnType<typeof useLastOrderByContractReferenceIdLazyQuery>;
export type LastOrderByContractReferenceIdSuspenseQueryHookResult = ReturnType<typeof useLastOrderByContractReferenceIdSuspenseQuery>;
export type LastOrderByContractReferenceIdQueryResult = Apollo.QueryResult<LastOrderByContractReferenceIdQuery, LastOrderByContractReferenceIdQueryVariables>;